module.exports = __webpack_public_path__ + "img/dashboard.14e82e1c.png";